import Spinner from "react-bootstrap/Spinner";
import style from '../../style/loader.module.css';
import "../../style/loader.css";

export default function SpinnerLoader(props) {
    return (
        <div className={`${style.loader_spinner} ${props?.paddingTop ? style.padding_top : props?.paddingbtm ? style.padding_btm : props?.padding ? style.padding_all : ""}`}>
            <Spinner animation="border" />
        </div>
    );
}
